import { qs, find, findAll, q } from './util.js';
import Swiper from 'swiper';
globalThis.initializeAfterAppRender = (init) => {
    if (init)
        introView();
    else
        introSkip();
    allMenu();
    window.addEventListener("keydown", function (e) {
        if ((e.key == "F5") || (e.ctrlKey && e.key == "r")) {
            e.preventDefault();
            const url = window.location.pathname + window.location.search;
            window.history.replaceState({}, "", url);
        }
    });
};
globalThis.DOMContentLoaded = () => {
    const quickArea = q('.quickArea');
    const allMenuBox = q('.allMenuBox');
    if (quickArea && allMenuBox && quickArea?.classList.contains("active")) {
        quickArea?.classList.remove("active");
        allMenuBox?.classList.remove("active");
    }
    const inputs = qs('.infoItem .item input[type="text"]');
    for (const input of inputs ?? []) {
        input.addEventListener('input', (e) => {
            const ele = e.target;
            if (ele.value.trim() !== '') {
                ele.classList.add('add');
            }
            else {
                ele.classList.remove('add');
            }
        });
        if (input.value.trim() !== '') {
            input.classList.add('add');
        }
    }
    fixedTap();
};
globalThis.DomFocus = (id) => {
    q(`#${id}`)?.focus();
};
//전체메뉴
function allMenu() {
    const quickArea = q('.quickArea');
    const allMenuBox = q('.allMenuBox');
    const menuBtn = find(quickArea, '.menuBtn');
    menuBtn?.addEventListener('click', function () {
        if (!quickArea?.classList.contains("active")) {
            quickArea?.classList.add("active");
            allMenuBox?.classList.add('active');
            console.log("on");
        }
        else {
            quickArea?.classList.remove("active");
            allMenuBox?.classList.remove("active");
            console.log("off");
        }
    });
}
function swiperMain() {
    const mainBanner = q(".cptMain .swiperContainer");
    if (!mainBanner)
        return;
    let mainSlide = new Swiper(".cptMain .swiperContainer", {
        slidesPerView: "auto",
        //loop:true,
        autoplay: {
            delay: 0,
            disableOnInteraction: false
        },
        pagination: {
            el: ".cptMain .swiper-pagination", // 수정
            clickable: true
        },
    });
}
//인트로부터 시작
function introView() {
    const main = document.querySelector('.cptMain');
    if (!main)
        return;
    setTimeout(function () {
        find(main, '.scene02')?.classList.add("sceneView");
        swiperMain(); // 메인슬라이드
    }, 5600);
}
//인트로 생략
function introSkip() {
    const main = document.querySelector('.cptMain');
    if (!main)
        return;
    main.classList.add("introSkip");
    swiperMain(); // 메인슬라이드
}
//상단 고정 탭 메뉴
function fixedTap() {
    const modSticky = q('.modSticky');
    if (!modSticky)
        return;
    const tabItems = findAll(modSticky, '.tabGroup .tabItem');
    const stickyConts = findAll(modSticky, '.stickyCont');
    const OFFSET = 300; // 헤더 등 상단 여유값, 필요시 조정
    function onScroll() {
        const scrollY = window.scrollY || window.pageYOffset;
        let currentIdx = 0;
        stickyConts.forEach((cont, i) => {
            const contTop = cont.getBoundingClientRect().top + window.scrollY - OFFSET;
            if (scrollY >= contTop) {
                currentIdx = i;
            }
        });
        tabItems.forEach((tab, i) => {
            if (i === currentIdx) {
                tab.classList.add('on');
                find(tab, '.btnTab')?.setAttribute('title', '선택됨');
            }
            else {
                tab.classList.remove('on');
                find(tab, '.btnTab')?.removeAttribute('title');
            }
        });
    }
    window.addEventListener('scroll', onScroll);
    onScroll(); // 초기화
    // 탭 클릭 시 해당 컨텐츠로 스크롤 이동
    tabItems?.forEach((tab, idx) => {
        const btn = find(tab, '.btnTab');
        btn?.addEventListener('click', function (e) {
            e.preventDefault();
            const targetCont = stickyConts.length >= 0 ? stickyConts[idx] : null;
            if (targetCont) {
                const targetTop = targetCont.getBoundingClientRect().top + window.scrollY - 80; // 상단 여유값
                window.scrollTo({ top: targetTop, behavior: 'smooth' });
            }
        });
    });
}
